var map = {
	"./appetizers.png": 1423,
	"./bbq.png": 9241,
	"./desserts.png": 4186,
	"./drinks.png": 8045,
	"./food-menu.png": 7199,
	"./kids-menu.png": 6347,
	"./salads.png": 6241,
	"./seafood.png": 242,
	"./sides.png": 2455,
	"./tacos.png": 5094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3766;